// extracted by mini-css-extract-plugin
export default {"section":"PA-z","sectionTitle":"QA-z","fieldWrapper":"RA-z","formField":"SA-z","disabled":"TA-z","formLabel":"UA-z"};